const locationListTab = (() => {
  const pageLocation = (document.getElementById("pageLocation") != null);
  if (pageLocation) {


    let sW = window.innerWidth;
    let sH = window.innerHeight;

    if (sW >= 768) {
    } else {

      let jsList = document.getElementById("jsList")
      let tabBoxs = jsList.querySelectorAll(".js-tab-box")
      let flexAreas = jsList.querySelectorAll(".js-flex-area")

      tabBoxs[0].classList.add('act');
      tabBoxs[0 + 2].classList.add('act');
      flexAreas[0].classList.add('act');

      tabBoxs.forEach((element, index) => {

        element.addEventListener('click', () => {

          for (let i = 0; i < flexAreas.length; i++) {
            tabBoxs[i].classList.remove('act');
            tabBoxs[i + 2].classList.remove('act');
            flexAreas[i].classList.remove('act');
          }

          if(index > 1){
            tabBoxs[index].classList.add('act');
            tabBoxs[index - 2].classList.add('act');
            flexAreas[index - 2].classList.add('act');
          }else{
            tabBoxs[index].classList.add('act');
            tabBoxs[index + 2].classList.add('act');
            flexAreas[index].classList.add('act');
          }

        });

      });

    }




  }
})()
export default locationListTab;